import { Fragment } from 'react'
import { useSelector } from 'react-redux'

import { useGroupActions } from 'hooks'
import { Group } from 'lib/_types'

import { selectIsLoggedIn } from 'store/selectors'

import Menu from 'components/Menu'

import { useGroupToolsMenu } from './useGroupToolsMenu'

const GroupTools = ({
  group,
  controlMenu,
  onGroupToolsMenuActionCallback,
}: {
  group: Group
  controlMenu?: Function
  onGroupToolsMenuActionCallback?: Function
}) => {
  const isLoggedIn = useSelector(selectIsLoggedIn)

  const { attemptLeaveGroup, attemptDeleteGroup, GroupActionConfirmBox } =
    useGroupActions()

  const { getMenu } = useGroupToolsMenu({
    group,
    attemptLeaveGroup,
    attemptDeleteGroup,
    onGroupToolsMenuActionCallback,
  })

  const menu = controlMenu ? controlMenu(group, getMenu()) : getMenu()

  if (!isLoggedIn) {
    return null
  }

  return (
    <Fragment>
      <Menu arrowPosition="right" icon="3dots-v" options={menu} />

      <GroupActionConfirmBox />
    </Fragment>
  )
}

export default GroupTools
